import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthProfile } from '@/context/AuthContext';

export const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { loading, session } = useAuthProfile();
  
  if (loading) return <div>Carregando...</div>;
  if (!session) return <Navigate to="/auth" replace />;
  return <>{children}</>;
};

export default ProtectedRoute;